import moment from "moment";
import { timeFormat } from "~/constants";

export const timeDurationConverter = (time: string, duration: number) => moment(time, timeFormat)
  .add(duration, "hours")
  .format(timeFormat);
